import "leaflet"
import L from "leaflet"
import "leaflet.fullscreen"
import route from "@main/config/routes.js"

document.addEventListener("DOMContentLoaded", function() {

    let mapNode = document.querySelectorAll(".js-map");

    if(mapNode.length > 0){

        mapNode.forEach((el) =>{

            let id = el.getAttribute("data-id"),
                lng = el.getAttribute("data-lng"),
                lt = el.getAttribute("data-lt");

            id = "map_" + id;
            el.setAttribute("id", id);

            let icon = L.icon({
                iconUrl     : route.assetsDir + "images/marker.svg",
                iconSize    : [25, 33],
                iconAnchor  : [20, 20],
                popupAnchor : [-3, -76]
            });

            let map = L.map(id).setView([lng, lt], 15);

            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
            }).addTo(map);

            L.marker([lng, lt], {
                icon: icon
            }).addTo(map);

            L.control.fullscreen({
                position: "topleft",
            }).addTo(map);
        });
    }
});


